import { ComponentType } from 'react';
import { useParams } from 'react-router';

import NotFoundPage from 'components/NotFoundPage';

import BlogArticleLayout from './components/BlogArticleLayout';
import BlogLandingPageView from './components/BlogLandingPage';
import type { ArticleMeta } from './types';

interface ArticleModule {
  default: ComponentType<{ components: Record<string, unknown> }>;
  meta: ArticleMeta;
}

const articleModules = import.meta.glob<ArticleModule>('./content/*.mdx', {
  eager: true,
});

const articles = Object.values(articleModules);

export function BlogLandingPage() {
  return (
    <BlogLandingPageView articles={articles.map((article) => article.meta)} />
  );
}

export default function BlogArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = articles.find((m) => m.meta.slug === slug);

  if (!article) {
    return <NotFoundPage />;
  }

  return <BlogArticleLayout meta={article.meta} Content={article.default} />;
}
